import { v4 as uuidv4 } from "uuid";
import {
    FormattedIdentityProviderCompanyIDPInfo,
    FormattedIdentityProviderCompanyIDPInfoParam,
    FormattedIdentityProviderCompanyIDPAttributeMap,
    IdentityProviderCompanyIDPInfo,
    IdentityProviderScheme
} from "@idw-types/data/identity-providers";

export const formatIdentityProviderDetailsCompanyIDPInfo = (
    companyIDPInfo: IdentityProviderCompanyIDPInfo,
    schemes: Array<IdentityProviderScheme>
): FormattedIdentityProviderCompanyIDPInfo => {
    if (companyIDPInfo) {
        const scheme = schemes.find(scheme => scheme.scheme === companyIDPInfo.tokenAuthScheme);
        const companyIDPInfoParams: Array<FormattedIdentityProviderCompanyIDPInfoParam> = companyIDPInfo.companyIDPInfoParams.map(param => { 
            return { ...param, uuid: uuidv4() };
        });
        const companyIDPAttributeMaps: Array<FormattedIdentityProviderCompanyIDPAttributeMap> = companyIDPInfo.companyIDPAttributeMaps.map(attribute => {
            return { ...attribute, uuid: uuidv4() };
        });
        return {
            authURL: companyIDPInfo.authURL,
            clientID: companyIDPInfo.clientID,
            clientSecret: companyIDPInfo.clientSecret,
            companyID: companyIDPInfo.companyID,
            companyIDPAttributeMaps: companyIDPAttributeMaps,
            companyIDPInfoParams: companyIDPInfoParams,
            id: companyIDPInfo.id,
            idpRedirectURL: companyIDPInfo.idpRedirectURL,
            jwksURL: companyIDPInfo.jwksURL,
            scope: companyIDPInfo.scope,
            status: companyIDPInfo.status,
            tokenAuthScheme: scheme,
            tokenURL: companyIDPInfo.tokenURL,
            userCredentialField: companyIDPInfo.userCredentialField,
            userInfoURL: companyIDPInfo.userInfoURL,
            wellKnownURL: companyIDPInfo.wellKnownURL
        };
    }

    return {
        authURL: null,
        clientID: null,
        clientSecret: null,
        companyID: null,
        companyIDPAttributeMaps: [],
        companyIDPInfoParams: [],
        id: null,
        idpRedirectURL: null,
        jwksURL: null,
        scope: null,
        status: null,
        tokenAuthScheme: null,
        tokenURL: null,
        userCredentialField: null,
        userInfoURL: null,
        wellKnownURL: null
    };
};